import { Chip as MuiChip } from "@mui/material";
import { styled } from "@mui/material/styles";

export const Chip = styled(MuiChip)(({ theme }) => ({
  height: "1.5rem",
  borderRadius: 12,
  fontSize: theme.typography.inter12.fontSize,
  fontWeight: 500,
  textTransform: "capitalize",
}));

export const ChipGreen = styled(Chip)(({ theme: { palette } }) => ({
  border: `solid 1px ${palette.colors.green.o50}`,
  backgroundColor: palette.colors.green.o10,
  color: palette.colors.green.o50,
}));

export const ChipBlue = styled(Chip)(({ theme: { palette } }) => ({
  border: `solid 1px ${palette.colors.blue.o50}`,
  backgroundColor: palette.colors.blue.o10,
  color: palette.colors.blue.o50,
}));

export const ChipOrange = styled(Chip)(({ theme: { palette } }) => ({
  border: `solid 1px ${palette.colors.orange.o50}`,
  backgroundColor: palette.colors.orange.o10,
  color: palette.colors.orange.o50,
  "& .MuiChip-deleteIcon": {
    color: palette.colors.orange.o50,
    width: "1rem",
    height: "1rem",
  },
}));

export const ChipRed = styled(Chip)(({ theme: { palette } }) => ({
  border: `solid 1px ${palette.colors.red.o50}`,
  backgroundColor: palette.colors.red.o10,
  color: palette.colors.red.o50,
}));

export const ChipPurple = styled(Chip)(({ theme: { palette } }) => ({
  border: `solid 1px ${palette.colors.purple.o70}`,
  backgroundColor: palette.colors.purple.o10,
  color: palette.colors.purple.o70,
  "& .MuiChip-deleteIcon": {
    color: palette.colors.purple.o70,
    width: "1rem",
    height: "1rem",
  },
}));

export const ChipYellow = styled(Chip)(({ theme: { palette } }) => ({
  border: `solid 1px ${palette.colors.yellow.o80}`,
  backgroundColor: palette.colors.yellow.o20,
  color: palette.colors.yellow.o80,
  "& .MuiChip-deleteIcon": {
    color: palette.colors.yellow.o80,
    width: "1rem",
    height: "1rem",
  },
}));
